import RoomCombinationEdit from './RoomCombinationEdit.vue';
import RoomCombination from './RoomCombination.vue';
export { RoomCombinationEdit };
export default RoomCombination;
